(function ($, adTags, googletag) {

    const getSizes = (strSizes) => {
        if (!strSizes) return [];
        return strSizes.split(",").map(x => x.split("x").map(y => parseInt(y)));
    };

    const getAdverts = () => $("div[data-ad-path]").map((index, elm) => {
        return {
            targetId: $(elm).attr("id"),
            path: $(elm).data("adPath"),
            sizes: getSizes($(elm).data("adSizes"))
        };
    }).get();

    const loadAdverts = () => {
        const adverts = getAdverts();
        const pubads = googletag.pubads();

        //  Define slots
        for (let ad of adverts) {
            googletag.defineSlot(ad.path, ad.sizes, ad.targetId).addService(pubads);
        }

        //  Set targetting
        for (let key in adTags) {
            if (adTags.hasOwnProperty(key)) {
                pubads.setTargeting(key, adTags[key]);
            }
        }

        //  Configure settings and services
        pubads.collapseEmptyDivs();
        pubads.enableSingleRequest();
        googletag.enableServices();

        //  Display Adverts
        for (let ad of adverts) {
            googletag.display(ad.targetId);
        }
    };

    googletag.cmd.push(() => loadAdverts());

})(jQuery, google_advert_targeting_tags, googletag);